export default __webpack_public_path__ + "static/media/certificado-minicurso-gasometria.7f427f13.svg";